// extracted by mini-css-extract-plugin
module.exports = {"base":"Button_base__166oF","primary":"Button_primary__I_9I9"};